import { Link } from "react-router-dom";

export const CustomButton = ({
  text,
  color,
  bgColor,
  borderColor,
  fill,
  padding,
  href,
}) => {
  return (
    <Link to={href}>
      <button
        className={`${color} ${bgColor} ${fill} ${borderColor} ${padding} text-sm uppercase border-2 px-16 lg:w-[18vw] w-full rounded-lg transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5`}
      >
        {text}
      </button>
    </Link>
  );
};
